import { useState, useEffect, useRef, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../../../redux/hook'
import { getAllAdminUsers } from '../../../../features/userslisting/api'
import { SHOW_LOADER, HIDE_LOADER } from '../../../../redux/slices/LoaderSlice'
import { Dropdown } from 'react-bootstrap'
import './index.css'
import Search from '../../../Form/Search'
import { User } from '../../../../features/userslisting/type'
import { debounce } from 'lodash'

const SearchComponent = () => {
    const navigate = useNavigate()
    const [results, setResults] = useState<User[]>([])
    const [dropdownVisible, setDropdownVisible] = useState(false)
    const [autosuggest, setAutosuggest] = useState<boolean>(false)
    const dispatch = useAppDispatch()
    const dropdownRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        setAutosuggest(true)
    }, [])

    const fetchResults = async (searchTerm: string) => {
        if (searchTerm?.length >= 3) {
            dispatch(SHOW_LOADER())
            try {
                const userlisting = await getAllAdminUsers({
                    advancedSearch: {
                        keyword: searchTerm,
                    },
                    isglobalSearch: true,
                    currentPage: 1,
                    recordsPerPage: 10,
                })
                setResults(userlisting?.data?.data)
                setDropdownVisible(true)
            } catch (error) {
                console.error(error)
            } finally {
                dispatch(HIDE_LOADER())
            }
        } else {
            setResults([])
            setDropdownVisible(false)
        }
    }

    // Debounced version of fetchResults
    const debouncedFetchResults = useCallback(debounce(fetchResults, 300), [])

    const handleSearch = (searchTerm: string) => {
        debouncedFetchResults(searchTerm)
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node)
            ) {
                setDropdownVisible(false)
            }
        }
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [dropdownRef])

    return (
        <div className="search-container" ref={dropdownRef}>
            <Search
                autosuggest={autosuggest}
                placeholder="Search Employee"
                onSearch={handleSearch}
            />
            {dropdownVisible && results.length > 0 && (
                <Dropdown.Menu show className="search-results-dropdown">
                    {results.map((user: any, index: any) => (
                        <Dropdown.Item
                            onClick={() =>
                                navigate(`/profile?userId=${user?.id}`)
                            }
                            key={index}
                        >
                            <span className="d-flex justify-content-between">
                                <div className="d-flex">
                                    <span className="user-name">
                                        {user?.name}
                                    </span>
                                    <span className="user-role">{`(${user.role})`}</span>
                                </div>

                                {user?.isActive === false && (
                                    <span className="user-active">
                                        Non-active
                                    </span>
                                )}
                            </span>

                            <span className="global-search-location">
                                {user.location !== null ? user.location : '--'}
                            </span>
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            )}
        </div>
    )
}

export default SearchComponent
